export default {"src":"/aplikace/_next/static/media/aplikace_hp_icon_philips.79a790a3.svg","height":15,"width":80,"blurWidth":0,"blurHeight":0};